import * as Yup from "yup"
import ionisConnectFormModel from "./ionisConnectFormModel"

const {
  formField: {
    currentPassword,
    password,
    passwordConfirm
  }
} = ionisConnectFormModel

const validationSchemaModifyConnected =
  Yup.object().shape({
    [currentPassword.name]: Yup.string().trim().min(8, password.invalidErrorMsg).required(`${currentPassword.requiredErrorMsg}`),
    [password.name]: Yup.string().trim().min(8, password.invalidErrorMsg).required(`${password.requiredErrorMsg}`),
    [passwordConfirm.name]: Yup.string().trim().min(8, password.invalidErrorMsg).required(`${passwordConfirm.requiredErrorMsg}`).oneOf([Yup.ref('password'), null], 'Les mots de passe ne correspondent pas.'),
  })

export default validationSchemaModifyConnected
